class InspirationDataHelper {
  constructor() {
    const {searchInspirationData = {}} = window;
    this.data = searchInspirationData;
  }

  getImgUrl = () => (
    this.data.imgUrl || null
  )

  getTheme = () => (
    this.data.theme || null
  )
}

const InspirationData = new InspirationDataHelper();

export default InspirationData;
